import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// ✅ Get all interfaces
export const getInterfaces = createAsyncThunk(
  "admin/allInterfaces",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/interface/all?page=${page}&limit=${limit}`;
      if (searchData) url += `&search=${searchData}`;
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Add new interface
export const addInterface = createAsyncThunk(
  "admin/addInterface",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/interface/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Edit interface
export const editInterface = createAsyncThunk(
  "admin/editInterface",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/interface/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Get single interface by ID
export const getSingleInterface = createAsyncThunk(
  "admin/singleInterface",
  async (interfaceId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/interface/${interfaceId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Delete interface
export const deleteInterface = createAsyncThunk(
  "admin/deleteInterface",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/interface/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Initial state
const initialState = {
  interfaceData: [],
  singleInterfaceData: [],
};

// ✅ Slice
const interfaceSlice = createSlice({
  name: "interfaceSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInterfaces.fulfilled, (state, action) => {
      state.interfaceData = action.payload.data;
    });
    builder.addCase(getSingleInterface.fulfilled, (state, action) => {
      state.singleInterfaceData = action.payload.data;
    });
  },
});

export default interfaceSlice.reducer;
